export const DEFAULT_LIVE_QUALITY = 'sd';

const getBaseChannel = channelId => String(channelId).replace(/0[12]$/, '');

export const getLiveQualityStorageKey = (deviceSerial, channelId) =>
  `vgps_quality_${deviceSerial}_${getBaseChannel(channelId)}`;

export const primeDefaultLiveQuality = (
  deviceSerial,
  channelId,
  quality = DEFAULT_LIVE_QUALITY
) => {
  if (!deviceSerial || !channelId) {
    return;
  }

  try {
    localStorage.setItem(
      getLiveQualityStorageKey(deviceSerial, channelId),
      quality
    );
  } catch (_) {
    // Ignore storage failures and let the SDK fall back to its own defaults.
  }
};
